let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("hGpNy")), load("8Fof4")]).then(() => parcelRequire('kRz17'));